export enum CashRequestStatus {
  AVAILABLE = "Disponible",
  TO_PROCESS = "A procesar",
  NEEDS_INFO = "Requiere informacion",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
}

export enum CheckRequestStatus {
  AVAILABLE = "Disponible",
  TO_PROCESS = "A procesar",
  NEEDS_INFO = "Requiere informacion",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
}

export enum TransferRequestStatus {
  PENDING = "En curso",
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  FAILED = "Fallida",
}

export enum ScheduledTransferStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  ON_REVISION = "En revision",
  FAILED = "Fallida",
  SCHEDULED = "Programada",
}

export enum SlotStatus {
  PENDING = "Pendiente",
  NO_TRANSPORT = "Sin flete",
  ASSIGNED = "Asignado",
  DELIVERED = "Entregado",
  TRANSIT = "En tránsito",
  FINISHED = "Finalizado",
}

export enum SellOrderStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  TO_PROCESS = "A procesar",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociacion",
  IN_COMMUNICATION = "En comunicacion",
  CONFIRMED = "Confirmada"
}

export enum CounterDeliveryStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  TO_PROCESS = "A procesar",
  IN_COMMUNICATION = "En comunicacion",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociacion",
  CONFIRMED = "Confirmada"
}

export enum FutureContractStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  TO_PROCESS = "A procesar",
  IN_COMMUNICATION = "En comunicacion",
  CANCELLED = "Cancelada",
  NEGOTIATION = "Negociacion",
  CONFIRMED = "Confirmada"
}

export enum SlotRequestStatus {
  REJECTED = "Rechazada",
  FINISHED = "Finalizada",
  PENDING = "Pendiente",
  SLOTS_PARTIALLY_ASSIGNED = "Cupos asignados parcialmente",
  SLOTS_ASSIGNED = "Cupos asignados",
  NEEDS_INFO = "Requiere informacion",
}

export enum BackupCheckStatus {
  PENDING_CHECK = "Pendiente de cheque",
  PENDING_ENDOSE = "Pendiente de endoso",
  FINISHED = "Finalizado",
  CANCELLED = "Cancelado",
}

export enum OrderStatus {
  PENDING = "Pendiente",
  CONFIRMED = "Confirmado",
  DELIVERED = "Entregado",
  TRANSIT = "En tránsito",
}

export enum SuppliesRequestStatus {
  PENDING_CONFIRMATION = "Pendiente de confirmación",
  NEEDS_INFO = "Requiere información",
  ORDER_CREATED = "Pedido creado",
  PARTIALLY_CONFIRMED = "Confirmado parcial",
  ORDER_CONFIRMED = "Pedido confirmado",
  IN_TRANSIT = "En camino",
  PARTIAL_DELIVERY = "Entrega parcial",
  DELIVERED = "Entregado",
  REJECTED = "Rechazada",
  CANCELLED = "Cancelada",
}

export enum SuppliesOrderStatus {
  PENDING = "Pendiente",
  CONFIRMED = "Confirmado",
  IN_TRANSIT = "En transito",
  DELIVERED = "Entregado",
}

export enum RequestTypes {
  CASH = 1,
  PHYSICAL_CHECK = 2,
  E_CHEQ = 3,
  SUPPLIES_REQUEST = 4,
  SUPPLIES_ORDER = 5,
}

export enum RequestTypeDescription {
  CASH = "Efectivo",
  PHYSICAL_CHECK = "Cheque Físico",
  E_CHEQ = "E-Cheq",
}

export enum ContactRequestStatus {
  PENDING = 1,
  CONTACTED = 2,
}
